import { motion } from "framer-motion";
import { ChevronUp, ChevronDown } from "lucide-react";
import Logo from "./Logo";

export const EASE = [0.16, 1, 0.3, 1];

export function Slide({ index, label, bg = "bg-bone", dark = false, children, id }) {
  const num = String(index + 1).padStart(2, "0");
  return (
    <section
      id={id}
      data-slide={index}
      data-testid={`slide-${num}`}
      className={`relative min-h-screen w-full snap-start overflow-hidden ${bg} ${
        dark ? "text-bone" : "text-inktext"
      }`}
    >
      <div
        className={`grain pointer-events-none absolute inset-0 z-0 ${
          dark ? "opacity-[0.18]" : "opacity-[0.05]"
        }`}
        aria-hidden="true"
      />
      {label && (
        <div className="absolute left-6 top-20 z-10 md:left-16 md:top-24 lg:left-24">
          <span
            className={`font-mono text-[11px] uppercase tracking-[0.25em] ${
              dark ? "text-mint/60" : "text-teal"
            }`}
          >
            {num} — {label}
          </span>
        </div>
      )}
      <div className="relative z-10 mx-auto flex min-h-screen w-full max-w-[1500px] flex-col justify-center px-6 py-24 md:px-16 lg:px-24">
        {children}
      </div>
      <div
        className={`absolute bottom-7 right-6 z-10 md:right-16 lg:right-24 ${
          dark ? "text-mint/40" : "text-ink/35"
        }`}
      >
        <span className="font-mono text-[10px] uppercase tracking-[0.25em]">
          PranIQ
        </span>
      </div>
    </section>
  );
}

export function FadeUp({ children, delay = 0, y = 26, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.75, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskLine({ children, delay = 0, className = "" }) {
  return (
    <span className={`block overflow-hidden pb-[0.13em] -mb-[0.13em] ${className}`}>
      <motion.span
        className="block"
        initial={{ y: "112%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 0.95, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function SlideTitle({ children, className = "" }) {
  return (
    <FadeUp
      className={`font-display text-[clamp(2.1rem,4.4vw,4.1rem)] font-medium leading-[1.05] tracking-[-0.02em] ${className}`}
    >
      {children}
    </FadeUp>
  );
}

export function SlideConclusion({ children, dark = false, delay = 0.35 }) {
  return (
    <FadeUp
      delay={delay}
      className={`mt-10 font-display text-xl italic md:mt-12 md:text-2xl ${
        dark ? "text-mint" : "text-gold"
      }`}
    >
      {children}
    </FadeUp>
  );
}
